// extracted by mini-css-extract-plugin
module.exports = {"desktopMenuItem":"DesktopMenuItem-desktopMenuItem--75bbf","desktopMenuItemLink":"DesktopMenuItem-desktopMenuItemLink--e53bb"};